import NoHtml from '@/plugin/filter/no-html';

export default {
  methods: {
    noHtml(val) {
      return NoHtml(val || '')
    }
  }
}
